export function isAdminUser(user) {
  return user?.role === 'admin';
}
